import hexToRgba from 'hex-rgba';
import colors from './colors';
var black = colors.black,
    gray = colors.gray,
    white = colors.white,
    negative = colors.negative,
    accent = colors.accent,
    dark = colors.dark;
var darkPalette = {
  background: {
    neutral: {
      primary: '#1A1A20',
      secondary: '#1D1D24',
      tertiary: '#15151B',
      popover: '#20202A',
      primaryTransparent: 'rgba(26, 26, 32, 0.56)',
      tertiaryTransparent: 'rgba(21, 21, 27, 0.56)',
      dialogOverlay: 'rgba(0, 0, 0, 0.56)'
    },
    semantic: {
      warning: '#352C1E',
      accent: '#28244C',
      positive: '#1D282A',
      negative: '#341F25',
      positiveGradient: 'linear-gradient(180deg, #1D1D24 0%, #232A2B 50%, #253835 100%)',
      negativeGradient: 'linear-gradient(180deg, #17171F 0%, #30262A 50.99%, #47292E 100%)'
    },
    gradient: {
      primary: 'linear-gradient(180deg, #1A1A20 3.5%, rgba(26, 26, 32, 0) 96.51%)',
      secondary: 'linear-gradient(180deg, #1D1D24 3.5%, rgba(29, 29, 36, 0) 96.51%)',
      tertiary: 'linear-gradient(180deg, #15151B 3.5%, rgba(21, 21, 27, 0) 96.51%)'
    }
  },
  label: {
    accent: '#6B5BFF',
    accentHigh: '#786AFF',
    accentHighest: '#8378FF',
    primary: '#E7E6EB',
    secondary: '#8A8B9F',
    secondaryHigh: '#A6A6B6',
    tertiary: '#817E87',
    tertiaryHigh: '#7F8091',
    placeholder: '#525365',
    inactive: 'rgba(131, 132, 156, 0.4)',
    positive: '#45BA8D',
    negative: '#FF6164',
    warning: '#F7CC1E',
    inverse: '#0A0A0A',
    primaryActive: '#786AFF',
    secondaryActive: '#A6A6B6',
    tertiaryActive: '#7F8091',
    plaseholder: '#525365'
  },
  fill: {
    primary: {
      highest: '#796BFF',
      high: '#6B5BFF',
      mid: '#5E4AF9',
      low: '#4D3DC7',
      muted: '#3C3096',
      overlay32: 'rgba(94, 74, 249, 0.32)',
      overlay24: 'rgba(94, 74, 249, 0.24)',
      overlay16: 'rgba(94, 74, 249, 0.16)',
      overlay8: 'rgba(94, 74, 249, 0.08)'
    },
    secondary: {
      highest: '#ACAEBD',
      high: '#8A8B9F',
      mid: '#6C6D82',
      low: '#515265',
      muted: '#404050',
      overlay32: 'rgba(78, 78, 110, 0.32);',
      overlay24: 'rgba(78, 78, 110, 0.24);',
      overlay16: 'rgba(78, 78, 110, 0.16);',
      overlay8: 'rgba(78, 78, 110, 0.08);'
    },
    positive: {
      highest: '#68D4A5',
      high: '#45BA8D',
      mid: '#288F6B',
      low: '#2D735B',
      muted: '#305C4F',
      overlay32: 'rgba(45, 115, 91, 0.32)',
      overlay24: 'rgba(45, 115, 91, 0.24)',
      overlay16: 'rgba(45, 115, 91, 0.16)',
      overlay8: 'rgba(45, 115, 91, 0.08)'
    },
    negative: {
      highest: '#FF8082',
      high: '#FF6164',
      mid: '#E84144',
      low: '#BD393D',
      muted: '#823436',
      overlay32: 'rgba(189, 57, 61, 0.32)',
      overlay24: 'rgba(189, 57, 61, 0.24)',
      overlay16: 'rgba(189, 57, 61, 0.16)',
      overlay8: 'rgba(189, 57, 61, 0.08)'
    },
    note: {
      highest: '#FCD356',
      high: '#FAC832',
      mid: '#EDAF11',
      low: '#BF8C14',
      muted: '#916A11',
      overlay32: 'rgba(191, 140, 20, 0.32)',
      overlay24: 'rgba(191, 140, 20, 0.24)',
      overlay16: 'rgba(191, 140, 20, 0.16)',
      overlay8: 'rgba(191, 140, 20, 0.08)'
    }
  },
  divider: {
    primary: '#08080A',
    secondary: '#101014',
    tertiary: '#060608',
    altPrimary: '#343442',
    altSecondary: '#262633'
  },
  static: {
    backgroundPrimary: '#1A1A20',
    black: '#0A0A0A',
    blackAlfa72: 'rgba(10, 10, 10, 0.72)',
    blackAlfa56: 'rgba(10, 10, 10, 0.56)',
    blackAlfa24: 'rgba(10, 10, 10, 0.24)',
    blackAlfa16: 'rgba(10, 10, 10, 0.16)',
    blackAlfa8: 'rgba(10, 10, 10, 0.08)',
    blackAlfa4: 'rgba(10, 10, 10, 0.04)',
    white: '#FFFFFF',
    whiteAlfa72: 'rgba(255, 255, 255, 0.72)',
    whiteAlfa56: 'rgba(255, 255, 255, 0.56)',
    whiteAlfa24: 'rgba(255, 255, 255, 0.24)',
    whiteAlfa16: 'rgba(255, 255, 255, 0.16)',
    whiteAlfa8: 'rgba(255, 255, 255, 0.08)',
    whiteAlfa4: 'rgba(255, 255, 255, 0.04)',
    primary: '#5E4AF9',
    primaryAlfa32: 'rgba(94, 74, 249, 0.32)',
    secondary: '#8A8B9F',
    secondaryAlfa32: 'rgba(78, 78, 110, 0.32)',
    positive: '#4BBF93',
    negative: '#FF6B6E',
    note: '#FFCB30'
  },
  shadow: {
    button: '0px 1px 3px rgba(0, 0, 0, 0.6)',
    accent: '0px 3px 6px -2px rgba(86, 36, 16, 0.38), 0px 6px 12px rgba(88, 40, 24, 0.27), 0px 8px 16px rgba(0, 0, 0, 0.6)',
    popover: '0px 4px 16px rgba(0, 0, 0, 0.7), 0px 16px 40px rgba(0, 0, 0, 0.32)',
    dialog: '0px 12px 16px rgba(0, 0, 0, 0.32), 0px 24px 56px rgba(0, 0, 0, 0.56)',
    cardEasy: '0px 6px 16px rgba(0, 0, 0, 0.2)',
    cardHeavy: '0px 1px 4px rgba(0, 0, 0, 0.2), 0px 6px 16px rgba(0, 0, 0, 0.4)',
    headerWeb: '0px 1px 4px rgba(0, 0, 0, 0.4), 0px 6px 16px rgba(0, 0, 0, 0.4)'
  },
  base: {
    accent: accent['1'],
    error: negative['2'],
    disabled: black['3']
  },
  input: {
    main: {
      text: white['2'],
      background: hexToRgba(gray['2'], 8),
      backgroundDisabled: hexToRgba(gray['2'], 4),
      backgroundHover: hexToRgba(gray['2'], 16),
      backgroundError: hexToRgba(negative['2'], 8),
      border: black['3'],
      borderDisabled: hexToRgba(black['3'], 56),
      borderHover: gray['1'],
      borderError: negative['2']
    },
    label: gray['2'],
    message: gray['2']
  },
  menuItem: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundSelected: hexToRgba(accent['1'], 16)
  },
  button: {
    backgroundDisabled: hexToRgba(gray['2'], 6),
    border: hexToRgba(accent['1'], 32),
    borderDisabled: hexToRgba(white['1'], 8)
  },
  iconButton: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundFocused: hexToRgba(accent['1'], 16)
  },
  toggle: {
    background: black['2'],
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundActivated: hexToRgba(accent['1'], 16)
  },
  text: {
    primary: white['2'],
    secondary: gray['2']
  },
  paper: {
    background: black['2'],
    shadow: {
      elevation1: '0px 1px 6px rgba(0, 0, 0, 0.12), 0px 1px 4px rgba(0, 0, 0, 0.12)',
      elevation2: '0px 3px 10px rgba(0, 0, 0, 0.23), 0px 3px 10px rgba(0, 0, 0, 0.16)',
      elevation3: '0px 10px 18px rgba(0, 0, 0, 0.22), 0px 14px 45px rgba(0, 0, 0, 0.25)'
    }
  },
  modal: {
    backdrop: hexToRgba(black['0'], 50)
  },
  dialog: {
    background: black['2']
  },
  dropDown: {
    background: dark['1']
  },
  dividerLegacy: {
    primary: dark['5'],
    secondary: dark['2']
  },
  switch: {
    icon: gray['3'],
    shadow: '0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    track: gray['2']
  },
  calendar: {
    day: {
      backgroundHover: hexToRgba(black['1'], 56),
      backgroundCurrent: hexToRgba(accent['1'], 16)
    }
  },
  avatar: {
    backgroundPrimary: black['0'],
    backgroundSecondary: black['1']
  },
  snackbar: {
    text: black['1'],
    background: white['2']
  },
  tooltip: {
    background: hexToRgba(black['0'], 90),
    color: white['1']
  }
};
export default darkPalette;